import axios from 'axios';
import { Storage } from 'react-jhipster';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

export const ACTION_TYPES = {
  CREATE_PASSWORD: 'account/CREATE_PASSWORD',
  RESET: 'account/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  createSuccess: false,
  createFailure: false,
  userRequest: {} as any
};

export type PasswordRegState = Readonly<typeof initialState>;

// Reducer
export default (state: PasswordRegState = initialState, action): PasswordRegState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.CREATE_PASSWORD):
      return {
        ...initialState,
        errorMessage: null,
        createSuccess: false,
        loading: true
      };
    case FAILURE(ACTION_TYPES.CREATE_PASSWORD):
      return {
        ...initialState,
        loading: false,
        createSuccess: false,
        createFailure: true
      };
    case SUCCESS(ACTION_TYPES.CREATE_PASSWORD):
      return {
        ...initialState,
        loading: false,
        createSuccess: true,
        createFailure: false,
        userRequest: action.payload.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

// Actions
const apiUrl = 'api/register';

export const savePassword = (login, key, password) => ({
  type: ACTION_TYPES.CREATE_PASSWORD,
  payload: axios.post(`${apiUrl}/activate`, { login, key, password })
});

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
